/**
 * Métricas de um dashboard que o equipamento realmente tem.
 *
 * O backend cruza a seção do schema de predefinições com os itens que existem
 * no Zabbix (restrito à interface, quando informada), então o retorno responde
 * de uma vez "o modelo tem esse dashboard configurado?" e "o item existe?".
 *
 * Retorna null quando a checagem não pôde ser feita — nesse caso o chamador
 * deve renderizar tudo (fail-open), porque um erro de rede não é prova de que o
 * equipamento não tem o dashboard configurado.
 *
 * Não deriva a interface de filterData de propósito: em dashboards de ONU o
 * `interfaceId` é "posicao - serial - username", que não casa com nome de
 * interface. Quem precisa restringir passa explicitamente.
 *
 * @param {Object} api - Instância axios da superfície (interno ou cliente)
 * @param {Object} filterData - Filtro do layout (hostId + identificadores)
 * @param {string} dash - Seção do schema ("sfp", "firewall", "linkSession", ...)
 * @param {string|string[]} [interface] - Interface(s) para restringir a busca
 * @param {AbortSignal} [signal]
 * @param {string} [itemsListUrl] - Sobrescrever no portal do cliente
 * @returns {Promise<string[]|null>} Chaves de métrica existentes, ou null
 */
export default async function buscarMetricasDisponiveis({
  api,
  filterData,
  dash,
  interface: interfaces,
  signal,
  itemsListUrl = "/zabbix/items/list",
}) {
  try {
    const response = await api.post(
      itemsListUrl,
      {
        hostid: filterData?.hostId,
        filterBySchema: true,
        ...(interfaces ? { interface: interfaces } : {}),
        fabricante: filterData?.fabricante,
        funcao: filterData?.funcao,
        modelo: filterData?.modelo,
        dash,
      },
      { signal },
    );

    const items = response?.data?.items;
    return Array.isArray(items) ? items : null;
  } catch (error) {
    console.error(error);
    return null;
  }
}
